export const addNewRowToTable = (newItem, items) => {
    if (items.length === 0)
        return [
            newItem
        ]
    else {
        const _items = []
        _items.push(newItem)
        items.map((item, index) => {
            _items.push({
                ...item,
                number: item.number + 1
            })
        })

        return _items
    }
}